import { layerClass } from "@freightsimple/ui-core/Theme/layers";
import type { ReactNode } from "react";

interface ViewShipmentsPageCardProps {
  children: ReactNode;
}

/**
 * The white card the booked-shipment page sits in, pulled up so it overlaps
 * the map above it.
 *
 * Break-glass Tailwind: the overlap is a negative offset against a sibling,
 * and the card caps at a page width that isn't on any component's scale.
 * No ui-core primitive expresses either, so the chrome is contained here
 * rather than spread through the page body.
 */
export function ViewShipmentsPageCard(props: ViewShipmentsPageCardProps) {
  return (
    <div className="flex w-full flex-col items-center">
      <div
        className={`relative -top-[72px] ${layerClass.raised} w-full max-w-[1216px] rounded-[3px] border border-border-strong bg-card`}
      >
        <div className="w-full p-12 pt-6">{props.children}</div>
      </div>
    </div>
  );
}
